import { TablePagination } from "@mui/material";
import React from "react";

export default function InboxPagination({
  totalCount,
  handlePageChange,
  page,
  loading,
}) {
  return (
    <TablePagination
      rowsPerPageOptions={[]}
      component="div"
      count={totalCount}
      rowsPerPage={10}
      page={page}
      onPageChange={handlePageChange}
      sx={styles.pagination}
      backIconButtonProps={
        loading
          ? {
              disabled: loading,
            }
          : undefined
      }
      nextIconButtonProps={
        loading
          ? {
              disabled: loading,
            }
          : undefined
      }
    />
  );
}

const styles = {
  pagination: {
    ".MuiTablePagination-toolbar": {
      inlineSize: "max-content",
      margin: "auto",
    },
    ".MuiTablePagination-actions": {
      color: "#302E2A",
    },
    ".MuiTablePagination-displayedRows": {
      position: "relative",
      top: "5px",
      fontFamily: "FustatSemiBold",
      fontSize: "14px",
      color: "#302E2A",
    },
  },
};
